import { emitAnalytics } from '@lib/api';
import React from 'react';
import { ReactComponent as RightArrow } from '../assets/arrow-right-two.svg';
import { ContentView } from '../components/content-view.styled';
import PageView from '../components/page-view';
import { useAnalytics } from '../lib/analytics';
import * as styled from './thank-you.styled';

const ThankYou: React.FC<{
    scrollTarget: React.RefObject<HTMLDivElement>;
}> = ({ scrollTarget }) => {
    const analytics = useAnalytics();
    const onClick = () => {
        emitAnalytics('boost-rental-income', analytics);
    };
    return (
        <PageView
            dataCy="thank-you"
            scrollTarget={scrollTarget}
            falseBottom={false}
            imageMobile={true}
            imageVariant="normal"
        >
            <ContentView>
                <styled.ThankYou>
                    <styled.Content>
                        <styled.Title>Thank you!</styled.Title>
                        <styled.Subtitle>
                            <p>
                              We’ll be in touch soon.
                            </p>
                            <br />
                            <p>
                                In the meantime, here are{' '}
                                <a
                                    href="https://www.vacasa.com/homeowner-guides/how-to-make-money-on-a-vacation-rental-property"
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={onClick}
                                >
                                    <u>10 proven ways to boost your vacation rental income</u>{' '}
                                    <RightArrow />
                                </a>
                            </p>
                        </styled.Subtitle>
                    </styled.Content>
                </styled.ThankYou>
            </ContentView>
        </PageView>
    );
};

export default ThankYou;
